import { Listbox as HeadlessListbox } from "@headlessui/react";
import { mdiCheck } from "@mdi/js";
import React, { Fragment } from "react";
import { joinClasses } from "../../utils/joinClasses";
import { Icon } from "../icon/Icon";
export const ListboxOption = ({ className, icon, iconPath, label, ...props }) => (React.createElement(HeadlessListbox.Option, { as: Fragment, ...props }, ({ active, selected }) => (React.createElement("div", { className: joinClasses(["nxm-dropdown-item", className], {
        "nxm-dropdown-item-active": active,
    }) },
    icon && (React.createElement("span", { className: "nxm-dropdown-item-icon flex items-center justify-center" }, icon)),
    iconPath && (React.createElement(Icon, { className: "nxm-dropdown-item-icon", path: iconPath, size: "none" })),
    React.createElement("span", { className: "nxm-dropdown-item-label" }, label),
    selected && (React.createElement(Icon, { className: "nxm-dropdown-item-icon", path: mdiCheck, size: "none" }))))));
